import React, { useEffect, useRef } from 'react';
import { useAuth } from '../context/AuthContext';

export const GoogleSignInButton: React.FC = () => {
  const buttonRef = useRef<HTMLDivElement>(null);
  const { isAuthenticated } = useAuth();

  useEffect(() => {
    if (!isAuthenticated && buttonRef.current && window.google) {
      // Render the Google Sign In button
      window.google.accounts.id.renderButton(buttonRef.current, {
        theme: 'outline',
        size: 'large',
        shape: 'rectangular',
        text: 'signin_with',
        logo_alignment: 'left'
      });
    }
  }, [isAuthenticated]);

  return <div ref={buttonRef} id="google-signin-button" />;
};
